
(function () {
  'use strict';
  angular.module('vcdms.vcprinter')
    .component('printereditor', {
      restrict: 'E',
      bindings: {
        printer: '<?',
        printerid: '<?'
      },
      template: `
        <printerform printer="vm.printer" parentsave="vm.childsave(printer)" oncancel="vm.oncancel()">
        <div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">
          <h3><i class="fa fa-check"></i> printer erfolgreich gespeichert!</h3>
        </div>
        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">
          <h3><i class="fa fa-info"></i> Das Anlegen einer/s neuen printer wurde abgebrochen!</h3>
        </div>
        <div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">
          <h3>
            <i class="fa fa-warning"></i> printer konnte nicht gespeichert werden,
            der Fehler wurde protokolliert!
            </h3>
        </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Printer', 'Rlog',
        function ($log, Printer, Rlog) {
          let vm = this;
          vm.save = save;
          vm.childsave = childsave;
          vm.oncancel = oncancel;
          
          vm.$onInit = function () {
            if ((angular.isUndefined(vm.printer) || !vm.printer.hasOwnProperty('_id'))
              && angular.isDefined(vm.printerid)) {
              getPrinter();
            }
          };

          vm.$onChanges = function (changes) {
            if (angular.isDefined(changes.printerid) && angular.isDefined(changes.printerid.currentValue) && changes.printerid.currentValue.length > 0) {
              vm.printerid = changes.printerid.currentValue;
              getPrinter();
            }
          }

          function getPrinter() {
            Printer.$find(vm.printerid).$then(function (printer) {
              vm.printer = printer;
            }, function (err) {
              $log.error('printer not found, id: ', vm.printerid, err);
              Rlog.error('printer', 'printereditor', 'printer not found', {_id: vm.printerid});
            });
          }
          
          function childsave(printer) {
            // vm.printer = angular.copy(printer);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (let key in printer) {
              if (printer.hasOwnProperty(key)) {
                vm.printer[key] = printer[key];
              }
            }
            vm.save();
          }
          
          function save() {
            if (vm.printer.$hasPendingActions()) {
              vm.printer.$cancel();
              vm.printer.$save().$then(function () {
                vm.saved = true;
              }, function (err) {
                vm.saved = false;
                $log.error('saving of printer failed: ', err);
                Rlog.error('vcutils.printer', 'printereditor', 'Saving of printer failed: ', {printerid: vm.printer._id});
              });
            }
            else {
              vm.printer.$save().$then(function () {
                vm.saved = true;
              }, function (err) {
                vm.saved = false;
                $log.error('saving of printer failed: ', err);
                Rlog.error('vcutils.printer', 'printereditor', 'Saving of printer failed: ', {printerid: vm.printer._id});
              });
            }
          }
          
          function oncancel() {
            vm.canceled = true;
          }

        }] // controller
    }); // component

// klammerfriedhof
}());
